// src/errors.ts
var BioweaveError = class extends Error {
  /** HTTP status code (0 for network errors / fetch threw). */
  status;
  /** Parsed response body (often `{detail: string}` from FastAPI). */
  body;
  constructor(message, status, body) {
    super(message);
    this.name = "BioweaveError";
    this.status = status;
    this.body = body;
  }
};
var BioweaveAuthError = class extends BioweaveError {
  /** The bearer the refused request carried (null: none), set by the client that made it;
   *  undefined when not recorded. A 401 on a token since replaced says nothing about the
   *  session that replaced it (app-401-recovery-before-sign-out-wiring). */
  sentWith;
  constructor(message, status, body) {
    super(message, status, body);
    this.name = "BioweaveAuthError";
  }
};
var BioweaveValidationError = class extends BioweaveError {
  constructor(message, body) {
    super(message, 422, body);
    this.name = "BioweaveValidationError";
  }
};
var BioweaveClientError = class extends BioweaveError {
  constructor(message, status, body) {
    super(message, status, body);
    this.name = "BioweaveClientError";
  }
};
var BioweaveServerError = class extends BioweaveError {
  constructor(message, status, body) {
    super(message, status, body);
    this.name = "BioweaveServerError";
  }
};
var BioweaveNetworkError = class extends BioweaveError {
  /** The underlying error caught from fetch(), if any. */
  cause;
  constructor(message, cause) {
    super(message, 0, null);
    this.name = "BioweaveNetworkError";
    this.cause = cause;
  }
};
function errorFromResponse(status, body) {
  if (status >= 200 && status < 300) return null;
  const detail = extractDetail(body) ?? `HTTP ${status}`;
  if (status === 401 || status === 403) {
    return new BioweaveAuthError(detail, status, body);
  }
  if (status === 422) {
    return new BioweaveValidationError(detail, body);
  }
  if (status >= 400 && status < 500) {
    return new BioweaveClientError(detail, status, body);
  }
  if (status >= 500) {
    return new BioweaveServerError(detail, status, body);
  }
  return new BioweaveError(detail, status, body);
}
function extractDetail(body) {
  if (body === null || typeof body !== "object") return null;
  const detail = body.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (first && typeof first === "object") {
      const msg = first.msg;
      if (typeof msg === "string") return msg;
    }
  }
  return null;
}

export {
  BioweaveError,
  BioweaveAuthError,
  BioweaveValidationError,
  BioweaveClientError,
  BioweaveServerError,
  BioweaveNetworkError,
  errorFromResponse
};
//# sourceMappingURL=chunk-EVGIRZO2.js.map